import { render, staticRenderFns } from "./UrlDetails.vue?vue&type=template&id=01dd42bd&scoped=true&"
import script from "./UrlDetails.vue?vue&type=script&lang=js&"
export * from "./UrlDetails.vue?vue&type=script&lang=js&"
import style0 from "./UrlDetails.vue?vue&type=style&index=0&id=01dd42bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd42bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow})
